import { Documents } from '.';

export interface GlobalDocuments extends Documents {
    pds?: string;
    fsg?: string;
    ltg?: string;
    fk?: string;
    rewards?: string;
    tac?: string;
    ra?: string;
    uhb?: string;
}
